import { getUserConfiguration } from 'owa-session-store';
import ClientTypeOptInState from 'owa-service/lib/contract/ClientTypeOptInState';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import PolicySettingsType from 'owa-service/lib/contract/PolicySettingsType';

export function shouldUseTodoModule() {
    const userConfiguration = getUserConfiguration();
    const userOptions = userConfiguration.UserOptions;
    const policySettings = userConfiguration.PolicySettings;

    const isExplicitLogon =
        userConfiguration &&
        userConfiguration.SessionSettings &&
        userConfiguration.SessionSettings.IsExplicitLogon;

    return (
        !isExplicitLogon &&
        userOptions &&
        userOptions.ReactOptinSettings &&
        (userOptions.ReactOptinSettings.TasksGraduatedFromBeta ||
            (userOptions.ReactOptinSettings.TasksEnabled &&
                isOptedIntoTodo(userOptions) &&
                isTodoAllowedByOutlookBetaPolicySetting(policySettings))) &&
        userOptions.ReactOptinSettings.TasksRedirectUrl !== null
    );
}

function isOptedIntoTodo(userOptions: UserOptionsType) {
    if (userOptions.ReactOptinSettings.TasksShouldUseSharedToggle) {
        // If we are using shared toggle, check ClientTypeOptInState.
        // With React Mail, Cal, People starting to cutover, but not Tasks,
        // we cannot assume that the user wants React Tasks as well.
        return userOptions.ClientTypeOptInState !== ClientTypeOptInState.Jsmvvm;
    } else {
        // We are not using a shared toggle (e.g. Consumer), so check TasksClientTypeOptInState.
        // In this case, users are auto-opted in (None is treated as opted in).
        return userOptions.TasksClientTypeOptInState !== ClientTypeOptInState.Jsmvvm;
    }
}

function isTodoAllowedByOutlookBetaPolicySetting(policySettings: PolicySettingsType) {
    /**
     * The scenario here is that Mail/Calendar has cutover, so we are in React.
     * But the admin has turned off OutlookBetaToggleEnabled OWA Mailbox Policy to prevent Tasks from
     * redirecting until To-Do is TierD compliant.
     * We do not need to check this check if TasksGraduatedFromBeta (cutover for Tasks).
     */
    if (policySettings && policySettings.OutlookBetaToggleEnabled === false) {
        return false;
    }

    return true;
}
